import { login, getUserInfo } from '@/api/api'

const state = {
    publishArticle: {}
}
const mutations = {
    // 设置发布文章
    SET_PUBLISH_ARTICLE(state, payload) {
        state.publishArticle = payload
    },
}
const actions = {
    async setPublishArticle(context, payload) {
        context.commit('SET_PUBLISH_ARTICLE', payload)
    },
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
